"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import AccountInfoDialog from "@/views/safemanagements/MoreSafeManager/dialog/AccountAccessAddRule.vue";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import API from "@ym-framework/api-utils";
let VisitorController = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.visit_mode = "white";
    this.gridBlackController = new GridController(
      new APIDataSource("api://base.auth/api/v7/account/visit_list/black")
    );
    this.gridWhiteController = new GridController(
      new APIDataSource("api://base.auth/api/v7/account/visit_list/white")
    );
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getVisitMode();
    });
  }
  changeRule() {
    return __async(this, null, function* () {
      yield this.$confirm(
        this.$t(
          "accountaccesscontrol.this_operation_will_switch_the_access_control_mode"
        ),
        this.$t("accountaccesscontrol.tips"),
        {
          confirmButtonText: this.$t("accountaccesscontrol.switching"),
          cancelButtonText: this.$t("accountaccesscontrol.cancel"),
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        try {
          let response = yield API.put(
            `api://base.auth/api/v7/accounts/visit_list/${this.visit_mode}`
          );
          yield this.refresh();
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      })).catch(() => {
        return;
      });
    });
  }
  getVisitMode() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          "api://base.auth/api/v7/accounts/info"
        );
        this.visit_mode = response.data.visit_mode;
        this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      if (this.visit_mode === "black") {
        this.gridBlackController.search();
        return;
      }
      if (this.visit_mode === "white") {
        this.gridWhiteController.search();
        return;
      }
    });
  }
  gridDelete(row) {
    return __async(this, null, function* () {
      yield this.$confirm(
        this.$t("accountaccesscontrol.do_you_want_to_delete_this_rule", { "name": row.name }),
        this.$t("accountaccesscontrol.tips"),
        {
          confirmButtonText: this.$t("accountaccesscontrol.delete"),
          cancelButtonText: this.$t("accountaccesscontrol.cancel"),
          type: "warning",
          roundButton: true
        }
      ).then(() => __async(this, null, function* () {
        try {
          let response = yield API.delete(
            `api://base.auth/api/v7/accounts/visit_list/items/${row.guid}`
          );
          this.$message.success(
            this.$t("accountaccesscontrol.delete_rule_succeeded")
          );
          this.refresh();
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      })).catch(() => {
        return;
      });
    });
  }
  addRule() {
    this._accountInfoDialog.open(this.visit_mode);
  }
};
__decorateClass([
  Ref("accountInfoDialog")
], VisitorController.prototype, "_accountInfoDialog", 2);
VisitorController = __decorateClass([
  Component({
    components: {
      UiGrid,
      AccountInfoDialog
    }
  })
], VisitorController);
export {
  VisitorController as default
};
